export default __webpack_public_path__ + "static/media/login-hero-image.ada08e9d.svg";